import { render, staticRenderFns } from "./SwitchingChannels.vue?vue&type=template&id=75052cc4&"
import script from "./SwitchingChannels.vue?vue&type=script&lang=js&"
export * from "./SwitchingChannels.vue?vue&type=script&lang=js&"
import style0 from "./SwitchingChannels.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports